import React, { useCallback, useState } from 'react';
import { Menu, Popover } from '@arco-design/web-react';
import { ToolItem } from '../ToolItem';
import { t } from '@bay-email/core';
import styleText from '../../styles/ToolsPopover.css?inline';

const list = [
	{
		value: 'normal',
		label: t('Wrap'),
	},
	{
		value: 'nowrap',
		label: t('No wrap'),
	},
];

export interface TextWrapProps {
	execCommand: (cmd: string, value: any) => void;
	getPopupContainer: () => HTMLElement;
	onBeforeInteract?: () => void;
}

export function TextWrap(props: TextWrapProps) {
	const { execCommand } = props;
	const [visible, setVisible] = useState(false);

	const onChange = useCallback(
		(val: string) => {
			props.onBeforeInteract?.();
			execCommand('textWrap', val);
			setVisible(false);
		},
		[execCommand, props],
	);

	return (
		<Popover
			trigger='click'
			color='#fff'
			position='bl'
			className='bay-email-extensions-Tools-Popover'
			popupVisible={visible}
			onVisibleChange={nextVisible => {
				if (nextVisible) {
					props.onBeforeInteract?.();
				}
				setVisible(nextVisible);
			}}
			content={
				<>
					<style>{styleText}</style>
					<div
						onMouseDownCapture={() => props.onBeforeInteract?.()}
						style={{
							maxWidth: 150,
							maxHeight: 240,
							overflowY: 'auto',
							overflowX: 'hidden',
						}}
					>
						<Menu
							onClickMenuItem={onChange}
							selectedKeys={[]}
							style={{ border: 'none', padding: 0 }}
						>
							{list.map(item => (
								<Menu.Item
									style={{ lineHeight: '30px', height: 30 }}
									key={item.value}
								>
									{item.label}
								</Menu.Item>
							))}
						</Menu>
					</div>
				</>
			}
			getPopupContainer={props.getPopupContainer}
		>
			<ToolItem
				title={t('Text Wrap')}
				icon={<span style={{ fontWeight: 600, fontSize: 12 }}>↵</span>}
			/>
		</Popover>
	);
}
